import React from 'react';
import * as contentful from 'contentful';
import CaseStudyItem from './CaseStudyItem';
import './CaseStudies.css';

class CaseStudies extends React.Component {

    state = {
        posts: []
    }

    client = contentful.createClient({
        space: 'zdmfg9it3osr',
        accessToken: 'acad145bb58925770f6d23aef3cb2bd05cdb1d61a6c4359e00f0c12efa216dd4'
    })

    componentDidMount() {
        this.fetchPosts().then(this.setPosts);
    }

    fetchPosts = () => this.client.getEntries({content_type: "caseStudy"});

    setPosts = response => {
        this.setState({
            posts: response.items
        });
    }

    render() {
        return (
            <section className="case-studies" id="work">
                { this.state.posts.map(({fields}, i) =>
                    <CaseStudyItem key={i} {...fields} isDisabled={this.props.isDisabled} />
                )}
                {/* { this.state.posts.map(({fields}, i) =>
                    <pre key={i}>{JSON.stringify(fields, null, 2)}</pre>
                )} */}
            </section>
        );
    }
}

export default CaseStudies;


// WEBPACK FOOTER //
// ./src/CaseStudies/CaseStudies.js